/**
 * Wrap call callback function so it can be executed only once.
 *
 * @param {Function} callback - function to be wrapped
 * @param {object} [context] - What context function is to be executed
 * @returns {Function} wrapped function
 */
const callOnce = (callback, context) => {
  let callbackFunc = callback;
  let result;

  return (...args) => {
    if (callbackFunc) {
      result = callbackFunc.apply(context || this, args);
      callbackFunc = null;
    }

    return result;
  };
};

export default callOnce;
